// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ykJxYAA4Q2DnI0BGFKHA {
  max-height: 100px;
  overflow-y: auto;
}

.AGldhpVPsfnsd07UWKlX {
  margin: 2px 4px 2px 0 !important;
}`, "",{"version":3,"sources":["webpack://./js/view/component/user-types/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gCAAA;AACF","sourcesContent":[".tag_wrapper {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.tag {\n  margin: 2px 4px 2px 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag_wrapper": `ykJxYAA4Q2DnI0BGFKHA`,
	"tag": `AGldhpVPsfnsd07UWKlX`
};
export default ___CSS_LOADER_EXPORT___;
